import {
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_RECEIVE,
    RESET_PASSWORD_ERROR,
    RESET_PASSWORD_ERROR_CLEAR,
} from "../../../store/actionTypes";

const initialState = {
    isLoading: false,
    isReseted: false,
    message: null,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_PASSWORD_REQUEST:
            state = {
                ...state,
                isLoading: true,
                isReseted: false,
                message: null,
            };
            break;
        case RESET_PASSWORD_RECEIVE:
            state = {
                ...state,
                isLoading: false,
                isReseted: true,
                message: null,
            };
            break;
        case RESET_PASSWORD_ERROR:
            state = {
                ...state,
                isLoading: false,
                isReseted: false,
                message: action.message,
            };
            break;
        case RESET_PASSWORD_ERROR_CLEAR:
            state = {
                ...state,
                isLoading: false,
                isReseted: false,
                message: null,
            };
            break;
        default:
            break;
    }

    return state;
};
